import { Icon } from "../../components/core/Icon";

import styles from "../../../styles/catalog.module.scss";
import { Currency } from "../../utils/Currency";
import { Badge } from "@components";
import dayjs from "dayjs";


export const mountPrice = (item) => {
	if (item.price >= 0 && item.sizes.length === 0) {
		return Number(item.price);
	}

	if(item.type == 'flavor') {
		return Math.min(item.sizes.map((s) => s.price || 0))
		
	}	

	if (item.sizes.length > 0) {
		const minValue = Math.min(...((item.sizes || []).map((s) => s.price || 0) || [0]));

		const minPricesSum = item.items
			.filter((question) =>
				!question.price_method || question?.price_method === "SUM"
			)
			.map((question) => {
				if (!question.items?.length) {
					return 0;
				}

				return Math.min(
					...(question.items.map(
						(options) => options.price * question.min
					) || [0])
				)
			})
			.reduce((total, optionPrice) => total + optionPrice, 0);

		const minPricesMax = item.items
			.filter((question) => question?.price_method === "MAX" && question.min)
			.map((question) => {
				const options = question?.items || [];

				const minPrice = options.reduce((minPrice, option) => {
					return minPrice === null
						? +option.price
						: Math.min(minPrice, +option.price);
				}, null);

				return minPrice;
			})
			.reduce((maxPrice, minQuestionPrice) => {
				return maxPrice === null
					? +minQuestionPrice
					: Math.max(maxPrice, +minQuestionPrice);
			}, null);


		return Number(minValue + minPricesSum + minPricesMax);
	}
}

export const mountOldPrice = (item) => {
	if (item.old_price >= 0 && item.sizes.length === 0) {
		return Number(item.old_price);
	}

	if(item.type == 'flavor') {
		return Math.min(item.sizes.map((s) => s.old_price || 0))
		
	}	

	if (item.sizes.length > 0) {
		const minValue = Math.min(...((item.sizes || []).map((s) => s.old_price || 0) || [0]));

		const minPricesSum = item.items
			.filter((question) =>
				!question.price_method || question?.price_method === "SUM"
			)
			.map((question) => {
				if (!question.items?.length) {
					return 0;
				}

				return Math.min(
					...(question.items.map(
						(options) => options.price * question.min
					) || [0])
				)
			})
			.reduce((total, optionPrice) => total + optionPrice, 0);

		const minPricesMax = item.items
			.filter((question) => question?.price_method === "MAX" && question.min)
			.map((question) => {
				const options = question?.items || [];

				const minPrice = options.reduce((minPrice, option) => {
					return minPrice === null
						? +option.price
						: Math.min(minPrice, +option.price);
				}, null);

				return minPrice;
			})
			.reduce((maxPrice, minQuestionPrice) => {
				return maxPrice === null
					? +minQuestionPrice
					: Math.max(maxPrice, +minQuestionPrice);
			}, null);

		return Number(minValue + minPricesSum + minPricesMax);
	}
}

export const isPromotionalPrice = (product) => {
	if (!product?.sizes || product?.sizes?.length <= 0)
		return false;

	return !!(product.sizes.find(size => size.promo_price === true));
	// return !!(product.sizes.find(size => size.price < size.old_price));
};

const replaceTimes = (timeRange) => {
    return {
        start: parseInt(timeRange.start.replace(":", "")),
        end: parseInt(timeRange.end.replace(":", ""))
    };
};

const isCurrentTimeValid = (availability) => {
	if (!availability || availability.length <= 0) return true

	const currentDayOfWeek = dayjs().day()

	const daySchedule = availability.find(
	  (item) => item.weekDay === currentDayOfWeek
	)

	if (!daySchedule) return false

	return daySchedule.times.some((timeRange) => {
	  const replacedTimes = replaceTimes(timeRange);
	  const { start, end } = replacedTimes
	  const currentTime = Number(dayjs().format('HHmm'))

	  return currentTime >= start && currentTime <= end
	})
}

export const ProductItem = ({ product, onEditProduct }) => {
	const oldPrice = mountOldPrice(product);
	const hasAddons = (product.items || []).length > 0;
	const hasSizes = (product.sizes || []).length > 1;

	if (product.name === "Gringo Lôko (Invenção do Rodolfim)") {
		console.log(product)
	}

	return (
		<div
			className={styles.product}
			// style={{ opacity: +(product.show) + .5 }}
			onClick={() => onEditProduct && onEditProduct(product)}
		>
			<div className={styles.details}>
				<div className="d-flex flex-column">
					<div className="d-flex align-center mb-15">
						{product.highlight && (
							<Icon name="star" solid size="1x" color={window.secondaryColor} />
						)}
						<div className="d-flex align-center">
							<p className={styles.name}>{typeof product.name === "object" ? product.name['pt-br'] : product.name}</p>
							{(!product.show || product.showAll === false || !isCurrentTimeValid(product?.availability)) && (
								<Badge name="Oculto" type="danger" absolute={false} />
							)}
						</div>
					</div>
					<p className={styles.description}>{product.description}</p>
				</div>
				<div className="d-flex flex-column">
				{isPromotionalPrice(product) &&
                    oldPrice &&
                    !(hasAddons || hasSizes) ? (
                      <p className={styles.price}>
                        <strike>{Currency.formatCurrency(oldPrice)}</strike>&nbsp;&nbsp;
                        <span className={styles.price}>
                          {Currency.formatCurrency(mountPrice(product))}
                        </span>
                      </p>
                    ) : isPromotionalPrice(product) &&
                      !hasSizes ? (
                      <p className={styles.price}>
                        A partir de&nbsp;
                        <span className={styles.price}>
                          {Currency.formatCurrency(mountPrice(product))}
                        </span>
                        &nbsp;&nbsp;
						{oldPrice && <strike>{Currency.formatCurrency(oldPrice)}</strike>}
                      </p>
                    ) : hasAddons || hasSizes ? (
                      <p className={styles.price}>
                        A partir de&nbsp;
                        <span className={styles.price}>
                          {Currency.formatCurrency(mountPrice(product))}
                        </span>
                      </p>
                    ) : (
                      <p className={styles.price}>
                        <span className={styles.price}>
                          {Currency.formatCurrency(mountPrice(product))}
                        </span>
                      </p>
                    )}
			</div>
			</div>
			<div className={styles.image}>
				{product.image ? (
					<img
						src={process.env.REACT_APP_ASSETS_URL + `/` + product.image}
						alt={product.name}
					/>
				) : (
					<div className="w-100 h-100 d-flex align-center justify-center">
						<Icon name="image-polaroid" size="2x" light />
					</div>
				)}
			</div>
		</div>
	);
};
